import { Tooltip, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}))(Tooltip);

const CustomTooltip = ({ content, maxLength, placement, className }) => {
  if (!content) return null;

  const spanStyle = {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  };

  if (content.length <= maxLength) {
    return (
      <span style={spanStyle} className={className}>
        {content}
      </span>
    );
  }

  const shortContent = content.substring(0, maxLength) + '...';

  return (
    <LightTooltip
      title={content}
      placement={placement}
      style={{ cursor: 'pointer' }}
    >
      <span style={spanStyle} className={className}>
        {shortContent}
      </span>
    </LightTooltip>
  );
};

CustomTooltip.defaultProps = {
  content: '',
  maxLength: 30,
  placement: 'top',
};

CustomTooltip.propTypes = {
  content: PropTypes.string,
  maxLength: PropTypes.number,
  placement: PropTypes.string,
};

export default CustomTooltip;
